import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: { display: 'flex' },
  inputDiv: { alignItems: 'center' },
  helperText: { color: 'red' },
  checkBoxText: { marginTop: theme.spacing(1.25) },
  inputBoxStyle: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1px',
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(2),
  },
  checkboxRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: theme.spacing(1),
  },

  memberUpdateModelTitle: {
    margin: theme.spacing(1, 0),
    color: '#999',
    fontWeight: '600',
    fontSize: '0.9rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
}));
